import { render, staticRenderFns } from "./ku-forum-content.vue?vue&type=template&id=39a66436"
import script from "./ku-forum-content.vue?vue&type=script&lang=js"
export * from "./ku-forum-content.vue?vue&type=script&lang=js"
import style0 from "./ku-forum-content.vue?vue&type=style&index=0&id=39a66436&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports